import { axios } from "@/core/axios";
import { Widget } from "@/modules/widgets/types";

export interface UserSearchResult {
    userGuid: string;
    email: string;
    name: string;
}

export interface WidgetShareRecord {
    id: number;
    widgetId: number;
    userId: string;
    sharedByEmail: string | null;
    sharedToEmail: string | null;
    accepted: boolean;
}

export const shareEndpoints = {
    searchUsers: async (search: string): Promise<UserSearchResult[]> => {
        const { data } = await axios.get<{ users: UserSearchResult[] }>("/users", {
            params: { search },
        });
        return data.users ?? [];
    },

    getWidgetShares: async (widgetId: number): Promise<WidgetShareRecord[]> => {
        const { data } = await axios.get<{ shares: WidgetShareRecord[] }>("/widget-share", {
            params: { widgetId },
        });
        return data.shares ?? [];
    },

    getMySharedWidgets: async (): Promise<Widget[]> => {
        const { data } = await axios.get<{ widgets: Widget[] }>("/widget-share/mine");
        return data.widgets ?? [];
    },

    removeMySharedWidget: async (widgetId: number): Promise<void> => {
        await axios.delete("/widget-share", { params: { widgetId } });
    },

    syncWidgetShares: async (payload: {
        widgetId: number;
        shares: Array<{ userId: string; sharedByEmail?: string | null; sharedToEmail?: string | null }>;
    }): Promise<void> => {
        await axios.put("/widget-share", payload);
    },
};
